module.exports = __webpack_public_path__ + "img/defrost-close.d299ab27.svg";